import React, { FC, useEffect } from 'react'
import TopBanner from '../../components/TopBanner/TopBanner'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs'
import { NavLink } from 'react-router-dom'
import s from './AboutUs.module.scss'
import { Helmet } from 'react-helmet-async'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { fetchAboutUs } from '../../store/slices/aboutUsSlice'

import MoreAboutUs from './MoreAboutUs/MoreAboutUs'
import OurTeam from './OurTeam/OurTeam'
import { scrollToTop } from '../../utils'

const AboutUs: FC = () => {
    const dispatch = useAppDispatch();
    const { aboutUs, loading } = useAppSelector(state => state.aboutUs);

    useEffect(() => {
        scrollToTop()
        dispatch(fetchAboutUs());
    }, [dispatch]);

    return (
        <>
            <Helmet>
                <meta property="og:title" content="Главная | Автоматизация технологических процессов и производств" />
                <meta property="og:description" content="Phoenix Programs предоставляет передовые решения в области автоматизации, веб-разработки и инженерии. Узнайте о наших услугах и проектах." />
                <meta name="twitter:title" content="Главная | Автоматизация технологических процессов и производств" />
                <meta name="twitter:description" content="Phoenix Programs предоставляет передовые решения в области автоматизации, веб-разработки и инженерии. Узнайте о наших услугах и проектах." />
                <link rel="canonical" href="https://phoenix-programs.com/about-us" />
                <title>О нас | Автоматизация технологических процессов и производств</title>
            </Helmet>
            <TopBanner title='О нас' />
            <Breadcrumbs>
                <NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/'} >Главная</NavLink>
                /
                <NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/about-us'} >О нас</NavLink>
            </Breadcrumbs>
            {!loading && aboutUs && (
                <>
                    <OurTeam description={aboutUs.description} image={aboutUs.images} />
                    <MoreAboutUs sections={aboutUs.sections} />
                </>
            )}
        </>
    )
}

export default AboutUs